import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Form,
	Button,
	Input,
	Upload,
	Image,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'userInfo':{},
			'storageInfo':{
				'usedStorage':'',
				'totalStorage':'',
			},
			'orderCount':{
				'pay_count':0,
				'production_count':0,
			},
		};
	}
	
	componentDidMount()
	{
		this.getUserInfo();
		this.getStorageInfo();
		this.getOrderCount();
		
		document.title = '企业资料 - ' + CommonValue.get('site_name');
	}
	
	getUserInfo()
	{
		let url = pcUrl('user','info');
		httpPost(url)
			.then(data=>{
				//手机号遮盖
				data['phone'] = data['phone'].replace(data['phone'].substr(3,4),'****');
				
				//data['is_manager'] = '0';
				this.setState({
					'userInfo':data,
				});
			});
	}
	
	getStorageInfo()
	{
		let url = pcUrl('company','storage');
		httpPost(url)
			.then(data=>{
				this.setState({
					'storageInfo':{
						'usedStorage':data['used_storage_exp'],
						'totalStorage':data['total_storage_exp'],
					},
				});
			});
	}
	
	getOrderCount()
	{
		let url = pcUrl('order','count');
		httpPost(url)
			.then(data=>{
				let orderCount = {
					'pay_count':data['pay_count'],
					'production_count':data['production_count'],
				};
				
				this.setState({
					'orderCount':orderCount,
				});
			});
	}
	
	render()
	{
		return (
			<>
				<div className="profile-head">
					<div className="profile-avatar">
						<dl>
							<dd className="float-left">
								<img src={this.state.userInfo['rank_avatar']} />
							</dd>
							<dt>
								{this.state.userInfo['company_name']}
							</dt>
							<dd>
								<span> 欢迎您回来！ </span>
								<br />
								<span> {this.state.userInfo['rank_name']} </span>
							</dd>
						</dl>
					</div>
					<div className="profile-data" style={{'width':'32%'}}>
						<ul>
							<li>
								<label> 凹鱼账号： </label>
								{this.state.userInfo['user_name']}
							</li>
							<li>
								<label> 绑定手机号： </label>
								{this.state.userInfo['phone']}
							</li>
						</ul>
						<div className="profile-data-bottom">
							<a href={ngUrl('user','changePassword')} className="text-blue">
								修改个人信息 &gt;&gt;
							</a>
						</div>
					</div>
					<div className="profile-data" style={{'width':'28%'}}>
						<ul>
							<li>
								<label> 账户余额： </label>
								￥{this.state.userInfo['money']}
							</li>
							<li>
								<label> 账户积分： </label>
								{this.state.userInfo['points']}
							</li>
							<li>
								<label> 已用空间： </label>
								<span className="storage-progress">
									{this.state.storageInfo.usedStorage}/{this.state.storageInfo.totalStorage}
								</span>
							</li>
						</ul>
						<div className="profile-data-bottom">
							<a href={ngUrl('user','charge')} className="text-blue">
								立即充值 &gt;&gt;
							</a>
						</div>
					</div>
					<div className="clear"></div>
				</div>
				
				<div className="profile-left">
					<div className="profile-panel">
						<div className="panel-head">
							<a href={ngUrl('user','order')} className="float-right text-gray">
								查看所有订单 &gt;
							</a>
							<h3>
								订单状态
							</h3>
						</div>
						<div className="panel-body">
							<dl>
								<dd className="float-left">
									<span className="clips user-profile-order-ico-1"></span>
								</dd>
								<dt>
									待付款订单：
									<span className="text-red">{this.state.orderCount['pay_count']}</span>
								</dt>
								<dd>
									<a href={ngUrl('user','order',{'order_status':0},true)}>
										查看全部待付款订单 &gt;
									</a>
								</dd>
								<dd className="clear"></dd>
							</dl>
							
							<dl>
								<dd className="float-left">
									<span className="clips user-profile-order-ico-2"></span>
								</dd>
								<dt>
									生产中订单：
									<span className="text-red">{this.state.orderCount['production_count']}</span>
								</dt>
								<dd>
									<a href={ngUrl('user','order',{'order_status':20,'order_type':0},true)}>
										查看全部生产中订单 &gt;
									</a>
								</dd>
								<dd className="clear"></dd>
							</dl>
						</div>
					</div>
				</div>
				<div className="profile-right">
					<div className="profile-panel">
						<div className="panel-head">
							<h3>
								你的专属会员权限
							</h3>
						</div>
						<div className="panel-body">
							<img src={this.state.userInfo['rank_rights']} />
						</div>
					</div>
				</div>
				<div className="clear"></div>
			</>
		);
	}
}

